<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading"><strong>Contatti</strong></div> -->
    <div class="panel-block">
      <table class="table is-fullwidth is-narrow">
        <!-- <thead>
          <tr style="font-size:10px;">
            <th>Titolo</th>
            <th>Nome</th>
            <th>Cognome</th>
            <th>Tel.</th>
            <th>Email</th>
            <th>Note</th>
            <th>News</th>
            <th></th>
          </tr>
        </thead>-->
        <tbody>
          <tr v-for="(contact, key) in formData" :key="contact.id">
            <td width="80">
              <b-field
                :message="showErrors[key]['title']"
                :type="showErrors[key]['title'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.title"
                  size="is-small"
                  placeholder="Sig."
                ></b-input>
              </b-field>
            </td>
            <td style="">
              <b-field
                :message="showErrors[key]['first_name']"
                :type="showErrors[key]['first_name'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.first_name"
                  size="is-small"
                  placeholder="nome"
                ></b-input>
              </b-field>
            </td>
            <td style="">
              <b-field
                :message="showErrors[key]['last_name']"
                :type="showErrors[key]['last_name'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.last_name"
                  size="is-small"
                  placeholder="cognome"
                ></b-input>
              </b-field>
            </td>
            <td style="width: 11rem">
              <b-field
                :message="showErrors[key]['phone']"
                :type="showErrors[key]['phone'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.phone"
                  size="is-small"
                  icon="phone"
                  placeholder="telefono"
                ></b-input>
              </b-field>
            </td>
            <td style="width: 15rem">
              <b-field
                :message="showErrors[key]['email']"
                :type="showErrors[key]['email'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.email"
                  size="is-small"
                  icon="envelope"
                  type="email"
                  placeholder="email"
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['notes']"
                :type="showErrors[key]['notes'] ? 'is-danger' : ''"
              >
                <b-input
                  v-model="contact.notes"
                  size="is-small"
                  placeholder="note"
                  @focus="modalEdit(contact, 'notes')"
                ></b-input>
              </b-field>
            </td>
            <td>
              <b-field
                :message="showErrors[key]['newsletter']"
                :type="showErrors[key]['newsletter'] ? 'is-danger' : ''"
              >
                <b-checkbox
                  v-model="contact.newsletter"
                  size="is-medium"
                ></b-checkbox>
              </b-field>
            </td>
            <td width="100">
              <div class="buttons">
                <button
                  v-if="!formHasEdits"
                  class="button is-small"
                  @click="$emit('generateEmail', contact, contractsNumber)"
                >
                  <b-icon icon="envelope-open" type="is-info" />
                </button>
                <button
                  class="button is-small"
                  @click="formData.splice(key, 1)"
                >
                  <b-icon icon="minus-circle" type="is-danger" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <div class="buttons">
                <button
                  class="button is-success is-small"
                  @click="formData.push({ customer: customerId })"
                >
                  <b-icon icon="plus"></b-icon>
                  <span>Aggiungi contatto</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small"
                  @click="reset"
                >
                  <b-icon icon="undo"></b-icon>
                  <span>Annulla</span>
                </button>
                <button
                  v-if="formHasEdits"
                  class="button is-small is-primary"
                  type="submit"
                  @click="submit()"
                >
                  <b-icon icon="save"></b-icon>
                  <span>Salva</span>
                </button>
                <b-field style="margin-left: auto">
                  <span
                    style="padding: 2px 5px 0; font-weight: bold; font-size: 90%"
                  >
                    Numero di licenze attive
                  </span>
                  <b-input
                    size="is-small"
                    type="number"
                    min="0"
                    max="100"
                    v-model="contractsNumber"
                  ></b-input>
                </b-field>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </b-collapse>
</template>

<script>
import cloneDeep from "lodash/cloneDeep"
import { call } from "vuex-pathify"

export default {
  props: {
    customerId: {
      type: Number,
      required: true
    },
    contacts: {
      type: Array,
      required: true
    },
    activeSupportContractsCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: cloneDeep(this.contacts),
      errors: [],
      contractsNumber: 0
    }
  },
  computed: {
    formHasEdits() {
      return JSON.stringify(this.contacts) != JSON.stringify(this.formData)
    },
    showErrors() {
      if (this.errors.length > 0) {
        return this.errors
      } else {
        let elements = []
        this.formData.forEach(() => {
          elements.push({})
        })
        return elements
      }
    }
  },
  mounted() {
    this.contractsNumber = this.activeSupportContractsCount
  },
  methods: {
    submitAction: call("contacts/update"),
    reset() {
      this.errors = []
      this.formData = cloneDeep(this.contacts)
      this.componentKey += 1
    },
    async submit() {
      try {
        await this.submitAction({
          customerId: this.customerId,
          data: this.formData
        })
        this.reset()
        this.$toast.open({
          message: "Modificato con successo",
          type: "is-success"
        })
      } catch (response) {
        // show errors in form
        this.errors = response.data
      }
    }
  }
}
</script>
